import { useQuery } from '@tanstack/react-query'
import { api } from './cliente'

export interface Opcion { id: number; codigo: string; nombre: string }
export interface Catalogos {
  areas: (Opcion & { nombreZh: string | null })[]
  obras: Opcion[]
  unidades: Opcion[]
  monedas: (Opcion & { simbolo: string })[]
  formasPago: Opcion[]
}

/** Los catálogos casi no cambian: se cachean una hora. */
export function useCatalogos() {
  return useQuery({
    queryKey: ['catalogos'],
    queryFn: () => api.get<Catalogos>('/catalogos'),
    staleTime: 3_600_000,
  })
}

export function aSelect(opciones: Opcion[] | undefined) {
  return (opciones ?? []).map((o) => ({ value: String(o.id), label: o.nombre }))
}
